
/* injects from baggage-loader */


import AbeldoChromaDialogTpl from './abeldo-chroma-dialog-scene.html';
import AbeldoChromaDialogController from './abeldo-chroma-dialog-scene.controller';

export default class AbeldoChromaDialogComponent {
    constructor() {
        this.templateUrl = AbeldoChromaDialogTpl;
        this.controller = AbeldoChromaDialogController;
        this.bindings = {
            scenes: '=',
            onFinish: '&'
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/abeldo-chroma-dialog-scene/abeldo-chroma-dialog-scene.component.js